import { canv } from '@/canv/global.js'

import {toolBase} from '@/tools/toolBase.js';
import { Group } from '@/group';

import { frameWidget } from '@/elements/frame'
import { selectionManager } from '../cursorTool';

export class frameTool extends toolBase {

    constructor() {
        super();
    }

    getToolView() {
        return `
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M3 6H21M18 3V21M3 18H21M6 3V21" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
        `;
    }

    getToolTipName() {
        return "Фрейм";
    }

    unselect() {
        super.unselect();

        this.ghost = null;
        this.clickMove = 0;
    }

    getWidgetWrapper(isGhost = false) {
        var newFrame = new frameWidget(0, 0);

        var newGroup = new Group(true, isGhost);
        newFrame.setParent(newGroup);
        return newGroup;
    }




    TryAction(type) {
        if (type === "mousedown") {
            this.clickMove = 1;

            const pt = canv.actionManager.getActionPoint();
            this.creationStartX = pt.x;
            this.creationStartY = pt.y;

        } else if (type === "mousemove") {
            if (this.ghost == null) {
                this.ghost = this.getWidgetWrapper(true);
            }

            if (this.clickMove > 0) {
                this.clickMove++;
            }

            if (this.clickMove === 0) {
                const pt = canv.actionManager.getActionPoint();

                const translateX = pt.x - this.ghost.startX;
                const translateY = pt.y - this.ghost.startY;
                this.ghost.translateGroup(translateX, translateY);
            } else if (this.clickMove > 2) {
                const pt = canv.actionManager.getActionPoint();

                let minX = pt.x < this.creationStartX ? pt.x : this.creationStartX;
                let maxX = pt.x > this.creationStartX ? pt.x : this.creationStartX;
                let minY = pt.y < this.creationStartY ? pt.y : this.creationStartY;
                let maxY = pt.y > this.creationStartY ? pt.y : this.creationStartY;

                const minSize = 250;
                if ((maxX - minX) < minSize) {
                    if (pt.x >= this.creationStartX) {
                        maxX = this.creationStartX + minSize;
                    } else {
                        minX = this.creationStartX - minSize;
                    }
                }

                if ((maxY - minY) < minSize) {
                    if (pt.y >= this.creationStartY) {
                        maxY = this.creationStartY + minSize;
                    } else {
                        minY = this.creationStartY - minSize;
                    }
                }

                this.ghost.onlyChild().startX = minX;
                this.ghost.onlyChild().startY = minY;
                this.ghost.onlyChild().width = maxX - minX;
                this.ghost.onlyChild().height = maxY - minY;
                this.ghost.onlyChild().updateDims();
            }


        } else if (type == "mouseup") {

            if (this.ghost == null) return;

            canv.canvasController.addGroup(this.ghost);
            canv.eventManager.openRecord();
            canv.eventManager.createBuildEvent("create", this.ghost);
            canv.eventManager.closeRecord();

            selectionManager.setSelected([this.ghost]);
        }

        canv.redraw();
    }



    draw() {

        if (this.ghost == null) return;

        canv.ctx.globalAlpha = 0.2;
        this.ghost.draw();
        this.ghost.drawOver();
        canv.ctx.globalAlpha = 1;
    }





    name = "frameTool";
    ghost = null;

    clickMove = 0;
    creationStartX = 0;
    creationStartY = 0;

    mode = "rect";
    color = "#3D62E1";
    borderColor = "transparent";
    borderDashType = "solid";
    borderWidth = 1;
}
